import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { IModalComponent, Btn, Field, NumberField, DateField, Radio, Checkbox, TextField, DropdownField, FormButtonDisabler, Validations } from '@samc/centricity-core';
import { IRunPricingParameter } from '@/Interfaces';

// Declare the component needed to be used for this html
@Component({
  name: 'assign-cusip-modal',
  components: { NumberField, DateField, Radio, Checkbox, TextField, DropdownField, Btn, Field, FormButtonDisabler }
})
export default class RunPricingModal extends Vue implements IModalComponent {
  @Prop() public addCloseProp!: (callback: () => Promise<IRunPricingParameter[] | undefined>) => void;
  @Prop() public cancelProp!: () => void;
  @Prop() public closeProp!: () => void;
  @Prop() public loanCount!: number | undefined;
  @Prop() public runPricingParameters!: IRunPricingParameter[];

  public async mounted() {

    this.addCloseProp(async () => {

      const messages: string[] = [];

      this.runPricingParameters.forEach(param => {
        if (param.required && param.value == null) {
          messages.push(param.displayName + ' is required');
        }
      });

      if (messages.length === 0) {
        return this.runPricingParameters;
      }

      this.$alert({
        title: 'Validation Errors Occurred',
        description: 'Please read below for details',
        type: 'error',
        errors: messages.slice(0, 10)
      });
    });
   
  }
}